import * as React from 'react';
import { Hr } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import { useProductData } from '../../../../../../context/product-context-hooks.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';
import { useEcommFacetContext } from '../../../../context/EcommFacetContext.js';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/inventory';
import { FacetPicker } from '../../../FacetPickers/components/FacetPicker.js';
import { FacetWithTextNode } from '../../../FacetPickers/components/FacetWithTextNode.js';
import { FacetWithImage } from '../../../FacetPickers/components/FacetWithImage.js';
import '@grandvisionhq/common';
import '@grandvisionhq/analytics';
import 'classnames';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/utils';
import '@grandvisionhq/icons';
import '@grandvisionhq/frk-routing';
import { FacetPickerDropdown } from '../../../FacetPickers/FacetPickerDropdown/FacetPickerDropdown.js';
import { getNotification } from '../../utils/get-notification.js';
import { getSelectedNode } from '../../utils/get-selected-node.js';
import { SingleVariantNode } from '../SingleVariantNode/SingleVariantNode.js';

const VariantTreeLevel = ({ className , treeLevelVariants , currentNode ,  })=>{
    const { getFormattedLabel  } = useIntl();
    const { product: { productType  } , facetConfigList ,  } = useProductData();
    const { handleVariantSelection , clickedFacetKeys , setClickedFacetKeys , setNotificationType , notificationType ,  } = useEcommFacetContext();
    const facetConfig = facetConfigList === null || facetConfigList === void 0 ? void 0 : facetConfigList.find((config)=>{
        var ref;
        return config.facetKey === ((ref = treeLevelVariants[0]) === null || ref === void 0 ? void 0 : ref.facetKey);
    });
    if (facetConfig === undefined || !treeLevelVariants.length) return null;
    const title = getFormattedLabel(facetConfig.titleLabelKey, {
        labelData: {
            number: treeLevelVariants.length
        }
    });
    const handleFacetSelection = (props)=>{
        var ref;
        const { name , sku , facetTerm  } = props;
        facetConfig === null || facetConfig === void 0 ? void 0 : (ref = facetConfig.onFacetSelection) === null || ref === void 0 ? void 0 : ref.call(facetConfig, {
            type: productType,
            name,
            id: sku,
            [facetConfig.facetKey]: facetTerm
        });
        setClickedFacetKeys(Array.from(new Set([
            ...clickedFacetKeys,
            facetConfig.facetKey
        ])));
        setNotificationType('info');
        handleVariantSelection(props);
    };
    const singleVariantFacet = treeLevelVariants.length === 1 ? treeLevelVariants[0] : undefined;
    const activeFacet = getSelectedNode(clickedFacetKeys, treeLevelVariants, facetConfig, currentNode);
    const { Right , Bottom  } = facetConfig.slots || {};
    const rightSlot = Right ? /*#__PURE__*/ React.createElement(Right, {
        treeLevelVariants: treeLevelVariants,
        facetKey: currentNode === null || currentNode === void 0 ? void 0 : currentNode.facetKey
    }) : undefined;
    const Notification = getNotification(clickedFacetKeys, treeLevelVariants, facetConfig, activeFacet, notificationType);
    if (singleVariantFacet && facetConfig.showSingleFacetAs !== 'display-type') {
        return /*#__PURE__*/ React.createElement(SingleVariantNode, {
            facetConfig: facetConfig,
            facetTerm: singleVariantFacet.facetTerm,
            rightSlot: rightSlot
        });
    }
    switch(facetConfig.displayType){
        case 'dropdown':
            return /*#__PURE__*/ React.createElement(React.Fragment, null, activeFacet && /*#__PURE__*/ React.createElement(FacetPickerDropdown, {
                title: title,
                rightSlot: rightSlot,
                onPick: handleFacetSelection,
                activeFacet: activeFacet,
                items: treeLevelVariants,
                productType: productType
            }), Notification && /*#__PURE__*/ React.createElement(Notification, {
                notificationType: notificationType
            }), Bottom ? /*#__PURE__*/ React.createElement(Bottom, null) : null, /*#__PURE__*/ React.createElement(Hr, null));
        case 'thumbnail':
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FacetPicker, {
                itemComponent: FacetWithImage,
                items: treeLevelVariants,
                onPick: handleFacetSelection,
                title: title,
                productType: productType,
                activeFacet: activeFacet,
                showFacetName: true,
                className: className,
                rightSlot: rightSlot
            }), Notification && /*#__PURE__*/ React.createElement(Notification, {
                notificationType: notificationType
            }), Bottom ? /*#__PURE__*/ React.createElement(Bottom, null) : null, /*#__PURE__*/ React.createElement(Hr, null));
        case 'text-node':
        default:
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FacetPicker, {
                itemComponent: FacetWithTextNode,
                facetTermFormatter: facetConfig.facetTermFormatter,
                items: treeLevelVariants,
                onPick: handleFacetSelection,
                title: title,
                productType: productType,
                activeFacet: activeFacet,
                showFacetName: false,
                className: className,
                rightSlot: rightSlot
            }), Notification && /*#__PURE__*/ React.createElement(Notification, {
                notificationType: notificationType
            }), Bottom ? /*#__PURE__*/ React.createElement(Bottom, null) : null, /*#__PURE__*/ React.createElement(Hr, null));
    }
};

export { VariantTreeLevel };
//# sourceMappingURL=VariantTreeLevel.js.map
